module.exports = __webpack_public_path__ + "static/media/overline.6736e93b.svg";